<h2 mat-dialog-title>
  {{
    isForDeprecation
      ? isAlgorithmDeprecated
        ? ('table.algorithms.undeprecate_algorithm_dialog.title' | translate)
        : ('table.algorithms.deprecate_algorithm_dialog.title' | translate)
      : ('table.algorithms.delete_algorithm_dialog.title' | translate)
  }}
</h2>

<mat-dialog-content>
  <p
    *ngIf="!isForDeprecation"
    class="description"
    [innerHTML]="
      'table.algorithms.delete_algorithm_dialog.description'
        | translate
          : {
              pipelineName: (pipelineName$ | async),
              pipelineStepId: data.deletionInformation?.pipelineStepId
            }
    "
  ></p>

  <p
    *ngIf="isForDeprecation"
    class="description"
    [innerHTML]="
      isAlgorithmDeprecated
        ? ('table.algorithms.undeprecate_algorithm_dialog.description'
          | translate : { algorithmName: data.deprecationInformation?.algorithmName })
        : ('table.algorithms.deprecate_algorithm_dialog.description'
          | translate : { algorithmName: data.deprecationInformation?.algorithmName })
    "
  ></p>

  <ts-algorithm-usage-grid
    *ngIf="!isAlgorithmDeprecated"
    class="usage-grid"
    [organizations]="data.pipelineUsage"
  ></ts-algorithm-usage-grid>
</mat-dialog-content>

<mat-dialog-actions class="custom-dialog-actions justify-content-around">
  <button
    #btnCancel
    mat-dialog-close
    class="btn m-2 flex-grow-1 widget cancel-button"
    (click)="cancel()"
    data-cy="cancel-button"
  >
    {{ 'button.cancel' | translate }}
  </button>
  <button
    #btnAccept
    mat-dialog-close
    [class.btn-danger]="!isAlgorithmDeprecated"
    [class.undeprecate-button]="isAlgorithmDeprecated"
    class="btn m-2 flex-grow-1 widget"
    color="primary"
    (click)="accept()"
    data-cy="confirm-button"
  >
    {{ 'button.confirm' | translate }}
  </button>
</mat-dialog-actions>
